module.exports = __webpack_public_path__ + "img/Avatar-85.64667296.svg";